import { render, staticRenderFns } from "./receipt-processor.vue?vue&type=template&id=6e2cdf54&scoped=true"
import script from "./receipt-processor.vue?vue&type=script&lang=js"
export * from "./receipt-processor.vue?vue&type=script&lang=js"
import style0 from "./receipt-processor.vue?vue&type=style&index=0&id=6e2cdf54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2cdf54",
  null
  
)

export default component.exports